export default "__VITE_ASSET__DPTSswjN__"